import { createFileRoute, getRouteApi, notFound } from "@tanstack/react-router";

import { parseCameraView } from "@/bear-viewer/camera-view";

import { WorkshopPage } from "./p.$projectId/workshop";
export const Route = createFileRoute("/p/$projectId/$branch/workbench/$view")({
  beforeLoad: ({ params }) => {
    if (
      params.branch === "main" ||
      !["changes", "model", "checks", "context", "document"].includes(
        params.view,
      )
    )
      throw notFound();
  },
  validateSearch: (
    search: Record<string, unknown>,
  ): { file?: string; cam?: string; plane?: string; thread?: string } => ({
    file: typeof search.file === "string" ? search.file : undefined,
    cam:
      typeof search.cam === "string" && parseCameraView(search.cam)
        ? search.cam
        : undefined,
    plane: typeof search.plane === "string" ? search.plane : undefined,
    thread: typeof search.thread === "string" ? search.thread : undefined,
  }),
  component: Workbench,
});
function Workbench() {
  const { projectId, branch, view } = Route.useParams();
  const { file } = Route.useSearch();
  const { indexUrl } = getRouteApi("/p/$projectId").useLoaderData();
  return (
    <WorkshopPage
      projectId={projectId}
      indexUrl={indexUrl}
      taskId={branch}
      taskView={
        view === "model" || view === "checks" || view === "context"
          ? view
          : undefined
      }
      taskFile={view === "document" ? file : undefined}
    />
  );
}
